import { useContext } from 'react';

import { OnAuthenticatedContext, type OnAuthenticatedFn } from '../contexts/OnAuthenticated';

/**
 * Read the consumer's optional `onAuthenticated` callback from context.
 * Returns `null` when no consumer callback is wired (standalone web
 * deploy) — screens fall back to `redirectAfterAuth` + `window.location`.
 *
 * Native consumers (VidaReactNative) supply a callback via
 * `<LoginRoot onAuthenticated={...}>`; every auth-success handler
 * consults this hook and prefers the callback over the URL redirect,
 * because those web paths (`/app/`, `/clients/`, …) are meaningless
 * inside a native app.
 */
export const useOnAuthenticated = (): OnAuthenticatedFn | null => useContext(OnAuthenticatedContext);
